import { GETCLIENTS_SUCCESS, GET_CLIENTS_STAFFS } from '../types';

const initialState = {
  clients: [],
  clientsStaff: []
};

export default function ClientManagerReducer(state = initialState, action) {
  switch (action.type) {
    case GETCLIENTS_SUCCESS:
      return {
        ...state,
        clients: action.payload
      };
    case GET_CLIENTS_STAFFS:
      return {
        ...state,
        clientsStaff: action.payload
      };

    default:
      return state;
  }
}
